import React, { useEffect, useState } from "react";
import Navbar from "../../SGI/EPIS/NavBarSSMT";
import { Chart } from "react-google-charts";
import Conexao from '../../Config/conexao';
import axios from 'axios';
import moment from 'moment';
import { colors } from "@mui/material";

export default function DashboardPlanoAcao(){


    //const dataAtual = moment();





    useEffect(() => {
      async function fetchData() {
          getStatu();
      }
      fetchData();
    }, []);


    const [data, setData] = useState([]);


    const [dataCheckList, setDataCheckList] = useState([]);

    

  
    async function getStatu() {
      try {
        const res = await axios.get(Conexao.api + 'ListaAcoesCheckListWEB.php');
  
        if (res.data.success === true) {

          const countsStatus = CountSatus(res.data.result);
          setData(countsStatus);


          const countCheckList = CheckListCount(res.data.result);
          setDataCheckList(countCheckList);
        }
      } catch (error) {
        // Tratar erros
      }
    };





    function CountSatus(data) {
      let countsStatus = {
        'Em andamento': 0,
        'Atrasados': 0,
        'Concluidos': 0,   
      };
    
      const dataAtual = moment(); // Assuming you have defined dataAtual somewhere
    
      data.forEach(i => {
        switch (true) {
          case (i.dataExecucao === null && moment(dataAtual).isSameOrAfter(moment(i.prazo, 'DD-MM-YYYY'), 'day')):
            countsStatus['Atrasados']++;
            break;
    
          case (i.dataExecucao !== null):
            countsStatus['Concluidos']++;
            break;
    
          case (i.dataExecucao === null && moment(dataAtual).isBefore(moment(i.prazo, 'DD-MM-YYYY'), 'day')):
            countsStatus['Em andamento']++;
            break;
    
          default:
            break;
        }
      });
    
      return countsStatus;
    };




    function CheckListCount(dataCheckList) {
      let countCheckList = {
        'Caminhão prancha': 0,
        'Alojamento': 0,
        'Componentes e acessórios': 0, 
        'Diário de sonda': 0,
        'Extintores': 0,
        'Inspeção sobre fadíga': 0, 
        'Ferramentas manuais': 0,
        'Fogareiro': 0,
        'Inspeção de campo': 0, 
        'Kit ambiental': 0,
        'Inspeção de meio ambiente': 0,
        'Praça de sondagem': 0, 
        'Pré-campo': 0,
        'Inspeção diária de veículos': 0,
        'Caminhão-pipa': 0, 
        'Ocorrências de campo': 0,
        'Relato de incidente ambiental': 0,
};

        dataCheckList.forEach(i => {
          switch (true) {
            case (i.checkList === "1"):
              countCheckList['Caminhão prancha']++;
              break;

                case (i.checkList === "2"):
                  countCheckList['Alojamento']++;
                  break;

                  case (i.checkList === "3"):
                    countCheckList['Componentes e acessórios']++;
                    break;


                    case (i.checkList === "4"):
                      countCheckList['Diário de sonda']++;
                      break;

                      case (i.checkList === "5"):
                        countCheckList['Extintores']++;
                        break;

                        case (i.checkList === "6"):
                          countCheckList['Inspeção sobre fadíga']++;
                          break;

                          case (i.checkList === "7"):
                            countCheckList['Ferramentas manuais']++;
                            break;


                            case (i.checkList === "8"):
                              countCheckList['Fogareiro']++;
                              break;

                              case (i.checkList === "9"):
                                countCheckList['Inspeção de campo']++;
                                break;

                                case (i.checkList === "10"):
                                  countCheckList['Kit ambiental']++;
                                  break;

                                  case (i.checkList === "11"):
                                    countCheckList['Inspeção de meio ambiente']++;
                                    break;

                                    case (i.checkList === "12"):
                                      countCheckList['Praça de sondagem']++;
                                      break;

                                      case (i.checkList === "13"):
                                        countCheckList['Pré-campo']++;
                                        break;

                                        case (i.checkList === "14"):
                                          countCheckList['Inspeção diária de veículos']++;
                                          break;

                                          case (i.checkList === "15"):
                                            countCheckList['Caminhão-pipa']++;
                                            break;

                                            case (i.checkList === "16"):
                                              countCheckList['Ocorrências de campo']++;
                                              break;
                                              
                                            case (i.checkList === "17"):
                                              countCheckList['Relato de incidente ambiental']++;
                                              break;

      

      
            default:
              break;
          }
        });
      
        return countCheckList;
        
      }



    return(<body className="container justify-content-center">
    <Navbar/>
    <br/>
      <div className='titulolaboratorio container-fluid '>
        <h1 className='texttitulo'>DashBoard de plano de ação dos check-list's</h1>
      </div> 
      <br/>
      <br/>

      <body className="container row"  /* style={{ backgroundColor: 'green', height: '70vh' }} */>

      <div className="col-5 mt-5 text-center " /* style={{ backgroundColor: 'Gainsboro', height: '50vh' }} */>
          <h4> Status</h4>
      <Chart   
/*               width={'550px'}*/
              height={'480px'} 
              chartType="PieChart"
              loader={<div> Loading Chart </div>}
              data={[
                ['Status', 'Quantidade'],
                ['Atrasados', data['Atrasados'] !== undefined ? data['Atrasados'] : 0],
                ['Concluidos', data['Concluidos'] !== undefined ? data['Concluidos'] : 0],
                ['Em andamento', data['Em andamento'] !== undefined ? data['Em andamento'] : 0],
              ]}
              options={{
                title: '',
                titleTextStyle: {
                  fontSize: 19,
                  textAlign: 'center',
                },
                chartArea: { width: '100%' },
                hAxis: {
                  title: 'Status',
                  minValue: 0,
                },
                vAxis: {
                  title: '',
                },
                legend: {
                  position: 'top',
                  alignment: 'center',
                },
                isStacked: true,
                pieHole: 0.4,
                pieSliceTextStyle: {
                  color: 'white',
                },
                colors: ['#dc3912','#3CB371' , '#FF9900' ],
              }}
              legendToggle
            />


      </div>
      <div className="col-7 text-center" /* style={{ backgroundColor: 'Silver', height: '50vh' }} */>
      
      <Chart
      className="ms-5"
            /*       width={'1200px'}*/
                  height={'60vh'} 
                  chartType="BarChart"
                  loader={<div> Loading Chart </div>}
                  data={[
                          ['CheckLists', 'Quantidade'],
                          ['Caminhão prancha', dataCheckList['Caminhão prancha'] || 0],
                          ['Alojamento', dataCheckList['Alojamento'] || 0],
                          ['Componentes e acessórios', dataCheckList['Componentes e acessórios'] || 0],
                          ['Diário de sonda', dataCheckList['Diário de sonda'] || 0],
                          ['Extintores', dataCheckList['Extintores'] || 0],
                          ['Inspeção sobre fadíga', dataCheckList['Inspeção sobre fadíga'] || 0],
                          ['Ferramentas manuais', dataCheckList['Ferramentas manuais'] || 0],
                          ['Fogareiro', dataCheckList['Fogareiro'] || 0],
                          ['Inspeção de campo', dataCheckList['Inspeção de campo'] || 0],
                          ['Kit ambiental ', dataCheckList['Kit ambiental'] || 0],
                          ['Inspeção de meio ambiente', dataCheckList['Inspeção de meio ambiente'] || 0],
                          ['Praça de sondagem', dataCheckList['Praça de sondagem'] || 0],
                          ['Pré-campo', dataCheckList['Pré-campo'] || 0],
                          ['Inspeção diária de veículos', dataCheckList['Inspeção diária de veículos'] || 0],
                          ['Caminhão-pipa', dataCheckList['Caminhão-pipa'] || 0],
                          ['Ocorrências de campo', dataCheckList['Ocorrências de campo'] || 0],
                          ['Relato de incidente ambiental', dataCheckList['Relato de incidente ambiental'] || 0],
                
                     ]}
                  options={{
                    title: 'Check-list',
                    titleTextStyle: {
                      fontSize: 19, 
                      textAlign: 'center'
                    },
                     chartArea: { width: '45%' }, 
                    hAxis: {
                      title: '',
                      minValue: 0,
                    },
                    vAxis: {
                      title: '',
                    }, 
                    
                    isStacked: true,
                  
                      colors: [  '#3CB371'],
                  }}
             
                />


      </div>







      

      </body>


      <br/><br/><br/>
    </body>
    )
}